export default Object.freeze({
  common: {
    subject: {
      Aborto: "Abortion",
      Género: "Gender",
      Eutanasia: "Euthanasia",
      Salud: "Health",
      Familia: "Family",
      Violencia: "Violence",
      Educación: "Education",
      Vida: "Life",
      Libertad: "Liberty",
      Otros: "Others",
    },
  },
  project: {
    projectType: {
      iniciativa: "Initiative",
      dictamen: "Opinion",
      sentencia: "Ruling",
    },
    position: {
      Registro: "Register",
      Comisiones: "Commissions",
      Pleno: "Plenary",
      "En revisora": "Under review",
      Ejecutivo: "Executive",
      Retirado: "Withdrawn",
      Desechado: "Dismissed",
      "Caducidad legislativa": "Legislative expiration",
      Publicado: "Published",
      "En vigor": "In force",
      Dictaminado: "Ruled",
      "Sala/Pleno": "Courtroom/Plenary",
      Resuelto: "Resolved",
    },
    type: {
      Abroga: "Repeal",
      Deroga: "Abolish",
      "Deroga y Reforma": "Abolish and Reform",
      Exhorto: "Exhortation",
      "Nueva Ley": "New Law",
      Reforma: "Reform",
      Reserva: "Reservation",
      Solicitud: "Request",
      Otro: "Other",
      "Acción inconstitucionalidad": "Unconstitutionality action",
      "Amparo directo": "Direct amparo",
      "Amparo directo en revisión": "Direct amparo in review",
      "Amparo en revisión": "Amparo in review",
      "Controversia constitucional": "Constitutional controversy",
    },
  },
  publication: {
    media: {
      Fotografia: "Photography",
      Periodico: "Newspaper",
      Radio: "Radio",
      "Red Social": "Social Network",
      Sitio: "Website",
      TV: "TV",
      Video: "Video",
      Testimonio: "Testimony",
      "Propuesta de Gobierno": "Government Proposal",
      Otro: "Other",
    },
    status: {
      Original: "Original",
      Cambiado: "Changed",
      Excluido: "Excluded",
    },
  },
  voting: {
    votingType: {
      discusion: "Discussion",
      votacion: "Voting",
      votacion_scjn: "Voting (SCJN)",
    },
    status: {
      "En estudio": "Under study",
      Finalizado: "Finalized",
    },
    result: {
      Pendente: "Pending",
      "No aprobado": "Not approved",
      Aprobado: "Approved",
    },
    direction: {
      Validez: "Validity",
      Invalidez: "Invalidity",
      Sobreseimiento: "Dismissal",
    },
    type: {
      Nominal: "Roll-call",
      Económica: "Economic",
      "Por cédula": "By ballot",
      Provisional: "Provisional",
    },
  },
  vote: {
    option: {
      "A favor": "In favor",
      "En contra": "Against",
      Abstencion: "Abstention",
      Ausente: "Absent",
      null: "No information",
      undefined: "No information",
      "": "No information",
    },
  },
  label: {
    list: "List",
    projects: "Projects",
    dictamen: "Opinion",
    politicians: "Politicians",
    politician: "Politician",
    votings: "Votings",
    votes: "Votes",
    vote: "Vote",
    publications: "Publications",
    accounts: "Establishments",
    account: "Establishment",
    comissions: "Commissions",
    comission: "Commission",
    plenos: "Plenary sessions",
    period: "Period",
    filters: "Filters",
    projectType: "Project type",
    votingType: "Voting type",
    alias: "Alias",
    position: "Position",
    subject: "Subject",
    subsubject: "Subsubject",
    type: "Type",
    otherType: "Other type",
    source: "Source",
    party: "Party",
    electionType: "Election type",
    electoralDistrict: "Electoral district",
    iniciativas: "Initiatives",
    adherencias: "Co-sponsorships",
    votaciones: "Votings",
    menciones: "Mentions",
    comision: "Commission",
    comisiones: "Commissions",
    curricula: "Curricula",
    licencias: "Leaves of absence",
    asistencias: "Attendance",
    generatedProjects: "Generated Projects",
    inicialistas: "Promoters",
    adherentes: "Co-sponsors",
    datePresentation: "Presentation date",
    dateResolution: "Resolution date",
    media: "Medium",
    status: "Status",
    publicationTitle: "Publication Title",
    publicationDrive: "Publication (Drive)",
    date: "Date",
    dateInicial: "Initial date",
    dateFinal: "Final date",
    webSource: "Source (web)",
    author_reporter: "Author/Reporter",
    mentioned: "Mentioned contact/politician",
    comments: "Comments",
    description: "Description",
    observations: "Observations",
    details: "Details",
    relations: "Relations",
    relationships: "Relationships",
    rapporteur: "Rapporteur",
    documents: "Documents",
    laws: "Laws",
    legislationAndLaws: "Legislation and Laws",
    inFavor: "In favor",
    against: "Against",
    abstention: "Abstention",
    absent: "Absent",
    votingText: "Voting Text (PDF)",
    votingDrive: "Voting (Drive)",
    votingOficial: "Official of SCJN",
    votingFinal: "Final ruling",
    projectDirection: "Project sense",
    summary: "Summary",
    isSubstitute: "Is substitute?",
    name: "Name",
    project: "Project",
    result: "Result",
    privacyAndTerms: "Privacy and terms",
    verifyPhone: "Verify phone",
    state: "State",
    action: "Action",
    true: "Yes",
    false: "No",
    plenary: "PLENARY",
    religiousInfo: "Religious information",
    additionalInfo: "Additional info",
    owner: "Owner",
    substitute: "Substitute",
    sex: "Sex",
    firstName: "First name(s)",
    lastName: "Last name(s)",
    post: "Position",
    mainPost: "Main position",
    birthdate: "Birthdate",
    age: "Age",
    kids: "Number of children",
    quotas: "By quotas",
    hobby: "Hobby/pastime",
    otherHobby: "Other hobby",
    professed: "Professed religion",
    otherProfessed: "Other professed religion",
    practiced: "Practiced religion",
    otherPracticed: "Other practiced religion",
    parish: "Parish",
    diocese: "Diocese",
    denomination: "Religious denomination",
    site: "Website",
    facebook: "Facebook",
    instagram: "Instagram",
    youtube: "Youtube",
    twitter: "Twitter",
    otherLink: "Other link",
    extension: "Extension",
    workEmail: "Work email",
    otherEmail: "Personal email",
    curriculum: "Curriculum (Link)",
    privateAddress: "Private address",
    zipCode: "Postal Code",
    country: "Country",
    town: "City",
    colony: "Neighborhood",
    street: "Street",
    externalNumber: "Ext number",
    internalNumber: "Int number",
    lot: "Lot",
    block: "Block",
    city: "Municipality / Borough",
    phone: "Phone",
    code: "Code",
    email: "E-mail",
    password: "Password",
    theme: "Theme",
    locale: "Language",
    search: "Search",
    maritalStatus: "Marital status",
    seeMore: "See more",
    seeLess: "See less",
    requestChanges: "Request adjustments",
    message: "Message",
    total: "Total",
    lists: "Lists",
    evaluation: "Evaluation",
    votingEvaluation: "General voting evaluation",
    evaluations: "Evaluations",
    evaluationsGeneral: "General evaluation",
    evaluationsPerSubject: "Evaluations by subject",
    votingEvaluationsPerSubject: "Voting evaluations by subject",
    driveDocument: "Document (Drive)",
    linkWeb: "Link (Web)",
    all: "All",
    unavailable: "Unavailable",
    active: "Active",
    inactive: "Inactive",
    headers: "Headers",
    legislation: "Legislation",
    comisionInitialist: "Promoting commission",
    dictamenIniciativa: "Initiative opinion",
    sentenciaFinal: "Final ruling",
    proyecto1: "Project 1",
    proyecto2: "Project 2",
    dictamenProject: "Project opinion",
    categoria: "Category",
    actual: "Current",
    percentagePeriod: "Percentage of the period",
  },
  description: {
    privacyAndTerms:
      "When you use our services, you trust us with your information.\nSome information present on this site may not be updated.\nAge requirement: 14 years or older.",
    requestChanges: "Send us a message requesting adjustments. Thank you!",
    searchGuide: "Try searching or filtering records.",
    chatAi: "Link to exclusive Chat AI (in testing)",
    noAuthorizationMessage:
      "It seems that access to the application has not yet been granted. Please talk to your administrator to get access.",
    noDataAvailable: "No data available",
    pleaseFilterOrSearch: "Please use the filters or search bar to refine the results.",
  },
  alert: {
    signIn: "Fill in the following form to access the platform.",
    insertCode: "Please insert below the code to verify your phone.",
    receiveCode: "To receive a code, the Captcha must be solved.",
    selectState: "Please select a state.",
  },
  text: {
    dateFormat: "DD/MM/YYYY",
  },
  select: {
    sex: {
      male: "Male",
      female: "Female",
    },
    theme: {
      light: "Light",
      dark: "Dark",
    },
    state: "State",
  },
  button: {
    signIn: "Sign in with {provider}",
    signOut: "Sign out",
    language: "English",
    confirm: "Confirm",
    update: "Update",
    agree: "Accept",
    disagree: "Reject",
    cancel: "Cancel",
    search: "Search",
    filter: "Filter",
    seeList: "View list",
    seeFilters: "View filters",
    seeEvaluations: "View evaluations",
    close: "Close",
    chatAi: "Chat AI (in testing)",
    printView: "Print view",
    typeReportTitle: "Type the report title",
    openFilters: "Open filters",
  },
  hint: {
    account: "Change the field and options for 'commission'.",
    projectType:
      "Change the fields and options for 'position', 'type' and 'laws'.",
  },
  rule: {
    required: "Please fill in this field.",
    invalid: "Invalid value. Try another value.",
    isNumber: "Use numbers only.",
    isPhoneNumber: "Phone numbers must be like +5255XXXXXXXX",
    isDate: "Please fill in with a valid date.",
    isCode: "Code is invalid.",
    one: "Please fill in at least one field.",
    emailIsValid: "Please fill in with a valid email.",
    passwordHasValidCharacters:
      "The password contains invalid characters: {chars}.",
    passwordHasValidLength:
      "The password must have at least {length} characters.",
    passwordHasLowerCase:
      "The password must have at least one lowercase letter.",
    passwordHasUpperCase:
      "The password must have at least one uppercase letter.",
    passwordHasNumber: "The password must have at least one number.",
    passwordHasSpecialCharacter:
      "The password must have at least one special character (@, $, !, %, *, #, ?) &, <, +, _).",
    credentialsAreNotWrong:
      "The credentials are incorrect. Make sure you entered your email and password correctly.",
  },
  Masculino: "Male",
  Femenino: "Female",
  Feminino: "Female",
  Soltero: "Single",
  Casado: "Married",
  Divorciado: "Divorced",
  Viudo: "Widowed",
  "Unión libre": "Common-law union",
  Soltera: "Single",
  Casada: "Married",
  Divorciada: "Divorced",
  Viuda: "Widowed",
});
